import React from "react";
import contextProvider from "../../../contextProvider";
import { withRouter } from "react-router-dom";
import { Row, Col, Label } from "reactstrap";

import _ReactOBaseComponent from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";

import Panel from "../../../_L1_components/Layout/Panel";
import ReactOTable from "../../../_L1_components/Elements/ReactOTable";
import ReactOActionBar from "../../../_L1_components/Elements/ReactOActionBar";
import ReactOForm from "../../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../../_L1_components/Elements/ReactOFormInput";

class ProbeSetupSync extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      form_data_probeConfs: [],
      confsCounter: 0,
    };
    super(props, initState);
    this._EXTENDER = "Sync";
  }

  loadMacroSync(cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        if (this.props.onConfLoad) {
          this.props.onConfLoad();
        }
        this.apiStore.fire("get_probe_macro_sync", {
          data: {
            probeuid: this.props.match.params.probeuid,
          },
          ___onSuccess: (status, data) => {
            if (this.mounted) {
              this.setState(
                {
                  data: data,
                  form_data_probeConfs: data.confs,
                  confsCounter: data.confs.length,
                  loading: false,
                },
                () => {
                  this._probe_sync_form.init(data);
                },
              );
            }
          },
        });
      },
    );
  }

  saveMacroSync(data, cb) {
    delete data.enableSync;
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("set_probe_macro_sync", {
          data: {
            probeuid: this.props.match.params.probeuid,
            value: data,
          },
          ___onSuccess: (status, data) => {
            if (this.mounted) {
              this.setState(
                {
                  loading: false,
                },
                () => {
                  this.loadMacroSync();
                  if (cb) {
                    cb(status, data);
                  }
                },
              );
            }
          },
        });
      },
    );
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    this.loadMacroSync();
  }

  onComponentWillUnmount() {
    this.mounted = false;
  }

  onRender() {
    // console.log("DEBUG :: ProbeSetupSync _ onRender", this.state.confsCounter);
    return (
      <_LoadingWrapper
        loadingPlug={this.state.loading || this.state.pre_loading}
      >
        <Panel
          className="mb-4 rounded-bottom"
          style={{
            minHeight: "100px",
          }}
        >
          <ReactOForm
            onSubmit={this.saveMacroSync.bind(this)}
            unsavedWarning={true}
            onControllerReady={(form_controller) => {
              this._probe_sync_form = form_controller;
            }}
            onFormDataChange={(form_data) => {
              this.setState({ form_data_probeConfs: form_data.confs || [] });
            }}
          >
            <Row>
              <Col xs={12} lg={6}>
                {this.props.probe_capabilities.ethernet === "yes" ||
                this.props.probe_capabilities.modem === "yes" ? (
                  <div>
                    <Label>CLOUD SYNCHRONIZATION USING</Label>
                    <ReactOTable
                      size="sm"
                      style={{ overflow: "hidden" }}
                      cols={[
                        {
                          data_key: "sync_method",
                        },
                        {
                          data_key: "sync_active",
                        },
                      ]}
                      rows={[
                        ...(this.props.probe_capabilities.ethernet === "yes"
                          ? [
                              {
                                sync_method: "Ethernet",
                                sync_active: (
                                  <ReactOActionBar align="right" padding="0">
                                    <ReactOFormInput
                                      type="switch"
                                      data_key="settings.sync"
                                      disabled
                                      size="sm"
                                      switchOnValue={this.props.cloudsyncServer}
                                      switchOffValue=""
                                    />
                                  </ReactOActionBar>
                                ),
                              },
                            ]
                          : []),
                        ...(this.props.probe_capabilities.modem === "yes"
                          ? [
                              {
                                sync_method: "UMTS/LTE",
                                sync_active: (
                                  <ReactOActionBar align="right" padding="0">
                                    <ReactOFormInput
                                      type="switch"
                                      data_key="settings.syncMobile"
                                      size="sm"
                                      switchOnValue={this.props.cloudsyncServer}
                                      switchOffValue=""
                                    />
                                  </ReactOActionBar>
                                ),
                              },
                            ]
                          : []),
                      ]}
                    />
                  </div>
                ) : null}
                <Row className="mb-3">
                  <Col xs={12}>
                    {this.state.form_data_probeConfs.length ? (
                      <ReactOTable
                        size="sm"
                        style={{ overflow: "hidden" }}
                        cols={[
                          {
                            data_key: "sync_method",
                          },
                          {
                            data_key: "sync_active",
                          },
                        ]}
                        rows={(() => {
                          let _TMP = [
                            {
                              sync_method: "Synchronization by the measures",
                              sync_active: (
                                <ReactOActionBar align="right" padding="0">
                                  <ReactOFormInput
                                    type="switch"
                                    data_key="enableSync"
                                    size="sm"
                                    onClick={(e) => {
                                      if (e.target.checked == false) {
                                        this.setState(
                                          {
                                            confsCounter: 0,
                                          },
                                          () => {
                                            this._probe_sync_form
                                              .getFormData()
                                              .confs.forEach(
                                                (conf, _CURR_idx) => {
                                                  this._probe_sync_form.handleFormChange(
                                                    "confs." +
                                                      _CURR_idx +
                                                      ".sync",
                                                    "",
                                                  );
                                                },
                                              );
                                          },
                                        );
                                      } else {
                                        this.setState({
                                          confsCounter:
                                            this.state.form_data_probeConfs
                                              .length,
                                        });
                                        this._probe_sync_form
                                          .getFormData()
                                          .confs.forEach((conf, _CURR_idx) => {
                                            this._probe_sync_form.handleFormChange(
                                              "confs." + _CURR_idx + ".sync",
                                              this.props.cloudsyncServer,
                                            );
                                          });
                                      }
                                    }}
                                    default="on"
                                    switchOnValue="on"
                                    switchOffValue="off"
                                  />
                                </ReactOActionBar>
                              ),
                            },
                          ];
                          this.state.form_data_probeConfs.forEach(
                            (_CURR_conf, _CURR_idx) => {
                              _TMP.push({
                                sync_method: (
                                  <span className="pl-3">
                                    {_CURR_conf.name}
                                  </span>
                                ),
                                sync_active: (
                                  <ReactOActionBar align="right" padding="0">
                                    <ReactOFormInput
                                      type="switch"
                                      data_key={"confs." + _CURR_idx + ".sync"}
                                      size="sm"
                                      switchOnValue={this.props.cloudsyncServer}
                                      switchOffValue={""}
                                      onClick={(e) => {
                                        if (e.target.checked) {
                                          this.setState({
                                            confsCounter:
                                              this.state.confsCounter + 1,
                                          });
                                        } else {
                                          this.setState(
                                            {
                                              confsCounter:
                                                this.state.confsCounter - 1,
                                            },
                                            () => {
                                              if (
                                                this.state.confsCounter == 0
                                              ) {
                                                this._probe_sync_form.handleFormChange(
                                                  "enableSync",
                                                  "off",
                                                );
                                              }
                                            },
                                          );
                                        }

                                        if (
                                          this._probe_sync_form.getFormData()
                                            .enableSync == "off" &&
                                          e.target.checked
                                        ) {
                                          this._probe_sync_form.handleFormChange(
                                            "enableSync",
                                            "on",
                                          );
                                        }
                                      }}
                                    />
                                  </ReactOActionBar>
                                ),
                              });
                            },
                          );
                          return _TMP;
                        })()}
                      />
                    ) : (
                      <div className="text-muted">No configured measures</div>
                    )}
                  </Col>
                </Row>
                <ReactOActionBar align="right" padding="0">
                  <ReactOFormInput
                    type="submit"
                    value="Save"
                    color="primary"
                    icon="save"
                  >
                    Save
                  </ReactOFormInput>
                </ReactOActionBar>
              </Col>
            </Row>
          </ReactOForm>
        </Panel>
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(
  withRouter(ProbeSetupSync),
  //	withDefinedContext(ProbeSetupSync, 'ProbeSetupSync', context_exposed_methods),
  {
    define: null,
  },
);
